// 路由表

import Vue from 'vue'
import VueRouter from 'vue-router'
import Game from '../components/home/game' // 首页模块
import Problem1 from '../components/home/problem1' // 问题1
import Problem2 from '../components/home/problem2' // 问题2
import Problem3 from '../components/home/problem3' // 问题3
import Problem4 from '../components/home/problem4' // 问题4
import Problem5 from '../components/home/problem5' // 问题5
import Load_results from  '../components/home/load_results' // 结果加载页
import Match_result from '../components/home/match_result' // 匹配结果
import Poster from "../components/home/poster" // 海报






Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history', // 去掉路由中的#号
  routes: [{
    path: '/game',
    name: 'game',
    component: Game,
    replace:true,
    meta: {
      title: "测一测你的“无障爱”人格类型，在线匹配你的专属好朋友"
    }
  },{
    path: '/problem1',
    name: 'problem1',
    component: Problem1,
    meta:{
      // title:"你会在意每天的穿搭吗？",
      title:"测一测你的“无障爱”人格类型，在线匹配你的专属好朋友"
    }
  },{
    path: '/problem2',
    name: 'problem2',
    component: Problem2,
    meta:{
      // title:"你休假时喜欢哪种放松形式？"
      title:"测一测你的“无障爱”人格类型，在线匹配你的专属好朋友"
    }
  },{
    path: '/problem3',
    name: 'problem3',
    component: Problem3,
    meta:{
      // title:"当你在异国他乡旅行时，想要交流却语言不通怎么办？"
      title:"测一测你的“无障爱”人格类型，在线匹配你的专属好朋友"
    }
  },{
    path: '/problem4',
    name: 'problem4',
    component: Problem4,
    meta:{
      // title:"当你的朋友心情不好时，你会怎么办？"
      title:"测一测你的“无障爱”人格类型，在线匹配你的专属好朋友"
    }
  },{
    path: '/problem5',
    name: 'problem5',
    component: Problem5,
    meta:{
      // title:"当对方和你意见不同无法达成一致时，你该怎么办？"
      title:"测一测你的“无障爱”人格类型，在线匹配你的专属好朋友"
    }
  },{
    path: '/load_results',
    name: 'load_results',
    component: Load_results,
    meta:{
      title:"正在为您找朋友"
    }
  },{
    path: '/match_result',
    name: 'match_result',
    component: Match_result,
    meta:{
      title:"匹配结果"
    }
  },{
    path: '/poster',
    name: 'poster',
    component: Poster,
    meta:{
      title:"你的专属海报"
    }
  }]





})



// WEBPACK FOOTER //
// ./src/router/index.js